import { cn } from '@/lib/utils';
import type { HistoricoUploadItem } from '@/services/SimplesNacional/GestaoDocumentos/api/HistoricoUploadApi';

export function HistoricoProgressBar({ item }: { item: HistoricoUploadItem }) {
  const descomp = parseInt(item.Descompactados, 10) || 0;
  const processados = parseInt(item.Processados, 10) || 0;
  const comErro = parseInt(item.ComErro, 10) || 0;

  if (descomp === 0) return <span className="text-muted-foreground text-xs">—</span>;

  const pct = Math.min(100, Math.round(((processados + comErro) / descomp) * 100));
  const isDone = pct === 100;

  return (
    <div className="flex flex-col items-center gap-1 w-full min-w-20">
      <span
        className={cn(
          'text-xs font-medium tabular-nums',
          isDone ? 'text-green-700' : 'text-blue-700'
        )}
      >
        {pct}%
      </span>
      <div className="w-full h-1.5 rounded-full bg-muted overflow-hidden">
        <div
          className={cn(
            'h-full rounded-full transition-all',
            isDone ? 'bg-green-500' : 'bg-blue-500'
          )}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
